import * as generalHelper from "../../../helpers/generalHelper";
import * as menuConstants from "../../../constants/menuConstants";
import * as methods from "../../../constants/serverMethods";
import * as optionHelper from "../../../helpers/optionHelper";
import * as optionsConstants from "../../../constants/optionsConstants";
import * as priceConstants from "../../../constants/entityConstants/priceConstants";
import * as propertyConstants from "../../../constants/propertyConstants";
import * as tableHelper from "../../../helpers/tableHelper";

import { AppState } from "../../../reducers";
import { Colorant } from "../../../types/colorant";
import { ColorantPackage } from "../../../types/colorantPackage";
import { Currency } from "../../../types/currency";
import { MenuItem } from "../../../types/menu";
import { PriceOption } from "../../../types/priceOption";
import { ServerRequest } from "../../../types/serverRequest";
import { SystemColorantScene } from "../../../components/scenes/system/SystemColorantScene";
import { Unit } from "../../../types/unit";

import { connect } from "react-redux";

export type PropsType = Readonly<{
    menuScene: MenuItem | null;
    priceDataPrivileges: MenuItem | null;
    currency: Currency | null;
    unitList: Array<Unit>;
    colorantTableConstant: string;
    colorantList: Array<Colorant>;
    colorantActiveList: Array<Colorant>;
    colorantLoading: boolean;
    colorantButtonLoading: boolean;
    colorantAvailableCount: number | null;
    colorantColumnOrder: Array<propertyConstants.Property>;
    colorantColumnVisibility: Record<propertyConstants.Property, boolean>;
    colorantColumnWidth: Record<propertyConstants.Property, number>;
    colorantOffset: number;
    colorantPage: number;
    colorantRowCount: number;
    colorantRowCountCustom: boolean;
    colorantSceneTableSize: Record<string, any> | null;
    colorantSearch: string | null;
    colorantSearchParams: Record<propertyConstants.Property, string>;
    colorantShowFilterRow: boolean;
    colorantShowGlobalSearch: boolean;
    colorantSortingAsc: boolean;
    colorantSortingCriterion: propertyConstants.Property | null;
    colorantTotalCount: number | null;
    colorantPackageTableConstant: string;
    colorantPackageList: Array<ColorantPackage>;
    colorantPackageActiveList: Array<ColorantPackage>;
    colorantPackageLoading: boolean;
    colorantPackageButtonLoading: boolean;
    colorantPackageAvailableCount: number | null;
    colorantPackageColumnOrder: Array<propertyConstants.Property>;
    colorantPackageColumnVisibility: Record<propertyConstants.Property, boolean>;
    colorantPackageColumnWidth: Record<propertyConstants.Property, number>;
    colorantPackageOffset: number;
    colorantPackagePage: number;
    colorantPackageRowCount: number;
    colorantPackageRowCountCustom: boolean;
    colorantPackageSearch: string | null;
    colorantPackageSearchParams: Record<propertyConstants.Property, string>;
    colorantPackageShowFilterRow: boolean;
    colorantPackageShowGlobalSearch: boolean;
    colorantPackageSortingAsc: boolean;
    colorantPackageSortingCriterion: propertyConstants.Property | null;
    colorantPackageTotalCount: number | null;
    optionPriceDefinition: PriceOption | null;
    optionPriceEnableCompanyCost: PriceOption | null;
    optionPriceEnablePriceGroups: PriceOption | null;
    optionUseTmcNames: boolean | null;
    sceneLayout: string | null;
}>;

const mapStateToProps = (state: AppState): PropsType => ({
    menuScene: generalHelper.getMenuItemByKey(
        state.navigation.menuList,
        menuConstants.MENU_MAIN_PAGE,
        menuConstants.PAGE_SYSTEM_COLORANTS
    ),
    priceDataPrivileges: generalHelper.getMenuItemByKey(
        state.navigation.menuList,
        menuConstants.MENU_MAIN_PAGE,
        menuConstants.PAGE_SYSTEM_PRICES
    ),
    currency: state.currency.systemCurrency,
    unitList: state.unit.allList,
    colorantTableConstant: menuConstants.TABLE_SYSTEM_COLORANTS,
    colorantList: state.colorant.systemList,
    colorantActiveList: state.colorant.systemActiveList,
    colorantLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ALL_SYSTEM_COLORANTS ||
            request.method === methods.METHOD_GET_SYSTEM_PRICE_OPTIONS ||
            request.method === methods.METHOD_DELETE_SYSTEM_COLORANT
    ),
    colorantButtonLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_SYSTEM_COLORANT_BY_ID ||
            request.method === methods.METHOD_EDIT_SYSTEM_COLORANT
    ),
    colorantAvailableCount: state.colorant.systemCountAvailable,
    colorantColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_SYSTEM_COLORANTS
    ),
    colorantColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_SYSTEM_COLORANTS
    ),
    colorantColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_SYSTEM_COLORANTS
    ),
    colorantOffset: state.colorant.systemOffset,
    colorantPage: state.colorant.systemPage,
    colorantRowCount: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT,
        menuConstants.TABLE_SYSTEM_COLORANTS
    ),
    colorantRowCountCustom: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT_CUSTOM,
        menuConstants.TABLE_SYSTEM_COLORANTS
    ),
    colorantSceneTableSize: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_TABLE_SIZE,
        menuConstants.PAGE_SYSTEM_COLORANTS
    ),
    colorantSearch: state.colorant.systemSearch,
    colorantSearchParams: state.colorant.systemSearchParams,
    colorantShowFilterRow: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_FILTER_ROW,
        menuConstants.TABLE_SYSTEM_COLORANTS
    ),
    colorantShowGlobalSearch: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_GLOBAL_SEARCH,
        menuConstants.TABLE_SYSTEM_COLORANTS
    ),
    colorantSortingAsc: tableHelper.getSortingObjectValue(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_SYSTEM_COLORANTS
        )
    ),
    colorantSortingCriterion: tableHelper.getSortingObjectKey(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_SYSTEM_COLORANTS
        )
    ),
    colorantTotalCount: state.colorant.systemCountTotal,
    colorantPackageTableConstant: menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES,
    colorantPackageList: state.colorantPackage.systemList,
    colorantPackageActiveList: state.colorantPackage.systemActiveList,
    colorantPackageLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ALL_SYSTEM_COLORANT_PACKAGES_BY_COLORANT ||
            request.method === methods.METHOD_DELETE_SYSTEM_COLORANT_PACKAGE
    ),
    colorantPackageButtonLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_SYSTEM_COLORANT_PACKAGE_BY_ID ||
            request.method === methods.METHOD_EDIT_SYSTEM_COLORANT_PACKAGE
    ),
    colorantPackageAvailableCount: state.colorantPackage.systemCountAvailable,
    colorantPackageColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
    ),
    colorantPackageColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
    ),
    colorantPackageColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
    ),
    colorantPackageOffset: state.colorantPackage.systemOffset,
    colorantPackagePage: state.colorantPackage.systemPage,
    colorantPackageRowCount: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT,
        menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
    ),
    colorantPackageRowCountCustom: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT_CUSTOM,
        menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
    ),
    colorantPackageSearch: state.colorantPackage.systemSearch,
    colorantPackageSearchParams: state.colorantPackage.systemSearchParams,
    colorantPackageShowFilterRow: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_FILTER_ROW,
        menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
    ),
    colorantPackageShowGlobalSearch: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_GLOBAL_SEARCH,
        menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
    ),
    colorantPackageSortingAsc: tableHelper.getSortingObjectValue(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
        )
    ),
    colorantPackageSortingCriterion: tableHelper.getSortingObjectKey(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_SYSTEM_COLORANT_PACKAGES
        )
    ),
    colorantPackageTotalCount: state.colorantPackage.systemCountTotal,
    optionPriceDefinition: generalHelper.getObjectByKey(
        state.price.systemOptionList,
        priceConstants.PRICE_OPTION_PRICE_DEFINITION
    ),
    optionPriceEnableCompanyCost: generalHelper.getObjectByKey(
        state.price.systemOptionList,
        priceConstants.PRICE_OPTION_ENABLE_COMPANY_COST
    ),
    optionPriceEnablePriceGroups: generalHelper.getObjectByKey(
        state.price.systemOptionList,
        priceConstants.PRICE_OPTION_ENABLE_PRICE_GROUPS
    ),
    optionUseTmcNames: optionHelper.getValueFromOptionDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_USE_TMC_NAMES
    ),
    sceneLayout: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_LAYOUT,
        menuConstants.PAGE_SYSTEM_COLORANTS
    )
});

export const SystemColorantSceneContainer = connect(mapStateToProps)(SystemColorantScene);
